<template>
  <button
    :class="[sizeClass, variantClass, isLoadingClass]"
    :disabled="disabled"
    :type="type"
    v-bind="$attrs"
    data-test="button"
    class="l-BaseButton"
  >
    <div class="l-BaseButton-container">
      <slot />
    </div>
    <ThreeDots
      v-if="loading"
      v-bind="loadingProps"
      class="l-BaseButton-loader"
    />
  </button>
</template>

<script>
import ThreeDots from '@/components/library/svg/animations/ThreeDots.vue'

const variants = {
  primary: 'variant-primary',
  danger: 'variant-danger',
  secondary: 'variant-secondary',
  tertiary: 'variant-tertiary',
  invisible: 'variant-invisible'
}
const sizes = {
  small: 'size-small',
  medium: 'size-medium',
  large: 'size-large'
}

export default {
  name: 'BaseButton',
  components: {
    ThreeDots
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'button',
      validator (value) {
        return ['button', 'submit', 'reset'].includes(value)
      }
    },
    variant: {
      type: String,
      required: false,
      default: 'primary',
      validator (value) {
        return Object.keys(variants).includes(value)
      }
    },
    size: {
      type: String,
      required: false,
      default: 'large',
      validator (value) {
        return Object.keys(sizes).includes(value)
      }
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    loadingDuration: {
      type: String,
      required: false,
      default: '1.2s'
    },
    loadingDelay: {
      type: String,
      required: false,
      default: '.3s'
    }
  },
  computed: {
    sizeClass () {
      return sizes[this.size]
    },
    variantClass () {
      return variants[this.variant]
    },
    isLoadingClass () {
      return this.loading ? 'is-loading' : ''
    },
    loadingProps () {
      return {
        width: this.size === 'small' ? 30 : 40,
        duration: this.loadingDuration,
        initialDelay: this.loadingDelay
      }
    }
  }
}
</script>
